module.exports = __webpack_public_path__ + "static/img/MY.31033d1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/countryFlag/MY.svg
// module id = R/T+
// module chunks = 55